import { render, staticRenderFns } from "./partinstallClone.vue?vue&type=template&id=fa96b992&scoped=true&"
import script from "./partinstallClone.vue?vue&type=script&lang=js&"
export * from "./partinstallClone.vue?vue&type=script&lang=js&"
import style0 from "./partinstallClone.vue?vue&type=style&index=0&id=fa96b992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96b992",
  null
  
)

export default component.exports